import React, { useState } from "react";
import { FaTrash, FaTimes } from "react-icons/fa";
import { apiDelete } from "../../API/Api_Url";
import { toast } from "react-toastify";

function FreelancerDeleteQuotationModal({ isOpen, onClose, JobPostData, GetAllPendingJobs, setExpandedJob }) {

    const [IsLoading, setIsLoading] = useState(false);

    const onDelete = async () => {
        try {
            setIsLoading(true);
            const response = await apiDelete(`api/freelance-engineer/DeleteBidOnJobPost/${JobPostData?._id}`);
            toast.success(response?.message || "Bid deleted successfully!");
            onClose()
            GetAllPendingJobs();
            setExpandedJob(null)
        } catch (error) {
            console.error("Error updating ServiceRequirement:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };


    if (!isOpen) return null;


    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-xl shadow-lg w-full max-w-md p-6 relative">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                >
                    <FaTimes className="h-5 w-5" />
                </button>

                <div className="flex flex-col items-center text-center">
                    <FaTrash className="text-red-600 text-4xl mb-3" />
                    <h2 className="text-lg font-semibold text-gray-800 mb-2">
                        Delete Quotation
                    </h2>
                    <p className="text-gray-600 text-sm mb-6">
                        Are you sure you want to delete your quotation? <br />
                        This action cannot be undone.
                    </p>
                </div>
                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-lg border text-gray-600 hover:bg-gray-100 transition"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() => { onDelete() }}
                        className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition"
                    >
                        {IsLoading ? 'Please Wait' : 'Delete'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default FreelancerDeleteQuotationModal;
